const AddToCartButton = (props) => {
  return (
    <div className="text-center mt-5">
      <button
        className="btn btn-cta fw-bold py-2 rounded-5 mt-auto"
        {...props}
      >
        Ambil Paket ini
      </button>
    </div>
  );
};

export default AddToCartButton;
